import { render, staticRenderFns } from "./dialogBox.vue?vue&type=template&id=a8b7d380&scoped=true&"
import script from "./dialogBox.vue?vue&type=script&lang=js&"
export * from "./dialogBox.vue?vue&type=script&lang=js&"
import style0 from "./dialogBox.vue?vue&type=style&index=0&id=a8b7d380&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b7d380",
  null
  
)

export default component.exports